import { assoc } from 'ramda';

import { type FullParams, type PageType } from '../url-mapping';

export const isIndexable = false;

export const canonicalUrlArgs = (
  pageType: PageType,
  params: FullParams
): [PageType, FullParams] => [pageType, assoc('region', 'us', params)];

/* eslint-disable sort-keys */
export const urls: Record<
  'ww',
  Record<string, '/l/ww/en' | `/l/ww/en/${string}`>
> = {
  ww: {
    // Home
    '': '/l/ww/en/home',

    // Alumni
    alumni: '/l/ww/en/alumni',

    // B2B
    enterprise: '/l/ww/en/b2b',
    'enterprise/contact': '/l/ww/en/b2b/apply',

    // Blog
    blog: '/l/ww/en/blog',

    // Campus
    remote: '/l/ww/en/campus/rmt',

    // Career
    career: '/l/ww/en/career',

    // Courses
    'web-development': '/l/ww/en/course/wd',
    'data-analytics': '/l/ww/en/course/da',
    'ux-ui-design': '/l/ww/en/course/ux',
    cybersecurity: '/l/ww/en/course/cy',

    // FAQ
    faq: '/l/ww/en/faq',

    // Financing Options
    'financing-options': '/l/ww/en/financing',

    // Forms
    apply: '/l/ww/en/apply',
    apply2: '/l/ww/en/full-apply',
    contact: '/l/ww/en/contact',
    'financing-form': '/l/ww/en/financing-form',
    'thank-you': '/l/ww/en/thank-you',

    // Syllabus Forms
    'ai-consulting-integration/syllabus': '/l/ww/en/syllabus/ac',
    'artificial-intelligence/syllabus': '/l/ww/en/syllabus/ai',
    'cloud-engineer/syllabus': '/l/ww/en/syllabus/ce',
    'cybersecurity/syllabus': '/l/ww/en/syllabus/cy',
    'data-analytics/syllabus': '/l/ww/en/syllabus/da',
    'data-engineering/syllabus': '/l/ww/en/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/ww/en/syllabus/dv',
    'digital-marketing/syllabus': '/l/ww/en/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/ww/en/syllabus/ml',
    'ai-product-manager/syllabus': '/l/ww/en/syllabus/pm',
    'ux-ui-design/syllabus': '/l/ww/en/syllabus/ux',
    'web-development/syllabus': '/l/ww/en/syllabus/wd',

    // PDP
    'ai-consulting-integration/remote': '/l/ww/en/pdp/ac/rmt',
    'artificial-intelligence/remote': '/l/ww/en/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/ww/en/pdp/ce/rmt',
    'cybersecurity/remote': '/l/ww/en/pdp/cy/rmt',
    'data-analytics/remote': '/l/ww/en/pdp/da/rmt',
    'data-engineering/remote': '/l/ww/en/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/ww/en/pdp/dv/rmt',
    'digital-marketing/remote': '/l/ww/en/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/ww/en/pdp/ml/rmt',
    'ai-product-manager/remote': '/l/ww/en/pdp/pm/rmt',
    'ux-ui-design/remote': '/l/ww/en/pdp/ux/rmt',
  },
};
/* eslint-enable sort-keys */
